import { jsxs, jsx } from "react/jsx-runtime";
const IconSortSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m11.707 7.293-3-3a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L7 7.414V15a1 1 0 1 0 2 0V7.414l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414Zm8 8a1 1 0 0 0-1.414 0L17 16.586V10a1 1 0 1 0-2 0v6.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l3 3a.997.997 0 0 0 1.414 0l3-3a1 1 0 0 0 0-1.414Z" })
    ]
  }
);
export {
  IconSortSvg
};
